import { toast } from "react-toastify";

function wargingError(message: string): void {
  toast.error(message);
}
function wargingSuccess(message: string): void {
  toast.success(message);
}
function wargingAlert(message: string): void {
  toast.warning(message, {
    style: {
      backgroundColor: "orange",
    },
  });
}
function wargingInfo(message: string): void {
  toast.info(message);
}
export default {
  wargingError,
  wargingSuccess,
  wargingAlert,
  wargingInfo,
};
